var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookmarkSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.5C4.5 2.94772 4.94772 2.5 5.5 2.5H18.5C19.0523 2.5 19.5 2.94772 19.5 3.5V20.5C19.5 20.8607 19.3058 21.1934 18.9917 21.3707C18.6777 21.5481 18.2925 21.5426 17.9836 21.3564L12 17.7483L6.01638 21.3564C5.70752 21.5426 5.3223 21.5481 5.00826 21.3707C4.69421 21.1934 4.5 20.8607 4.5 20.5V3.5Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkSolid);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMy41QzQuNSAyLjk0NzcyIDQuOTQ3NzIgMi41IDUuNSAyLjVIMTguNUMxOS4wNTIzIDIuNSAxOS41IDIuOTQ3NzIgMTkuNSAzLjVWMjAuNUMxOS41IDIwLjg2MDcgMTkuMzA1OCAyMS4xOTM0IDE4Ljk5MTcgMjEuMzcwN0MxOC42Nzc3IDIxLjU0ODEgMTguMjkyNSAyMS41NDI2IDE3Ljk4MzYgMjEuMzU2NEwxMiAxNy43NDgzTDYuMDE2MzggMjEuMzU2NEM1LjcwNzUyIDIxLjU0MjYgNS4zMjIzIDIxLjU0ODEgNS4wMDgyNiAyMS4zNzA3QzQuNjk0MjEgMjEuMTkzNCA0LjUgMjAuODYwNyA0LjUgMjAuNVYzLjVaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };